import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'
export const constantRouterMap = [
  //不属于菜单页面
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', id: '1',  role: [], icon: 'home',  },
    hidden: false,
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', id: '1-1',  role: [], icon: 'home' },
    }]
  },
  {
    path: '/manager/fixedPassword',
    component: () => import('@/views/manager/fixedPassword'),
    hidden: true
  },
]

const asyncRoutes = [
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', id: '1',  role: [], icon: 'home', },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', id: '1-1',  role: [], icon: 'home' },
    }]
  },
  //商品管理
  {
    path: '/goods',
    component: Layout,
    redirect: '/goods/product',
    name: 'goods',
    meta: { title: '商品管理', id: '2',  role: [], icon: 'product' },
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/goods/product/index'),
        meta: { title: '商品管理', id: '2-1',  role: [], icon: 'product-brand' }
      },
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/goods/category/index'),
        meta: { title: '类目管理', id: '2-2',  role: [], icon: 'product-attr' },
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: () => import('@/views/goods/logistics/index'),
        meta: { title: '物流管理', id: '2-3',  role: [], icon: 'product-cate' },
      },
      {
        path: 'logistics/create',
        name: 'logisticsCreate',
        component: () => import('@/views/goods/logistics/create'),
        meta: { title: '物流管理', id: '2-4',  role: [], icon: 'product-cate', is_children: true, children_path: '/logistics' },
        hidden: true
      },
      {
        path: 'up',
        name: 'up',
        component: () => import('@/views/goods/up/index'),
        meta: { title: '上架管理', id: '2-5',  role: [], icon: 'sms-ad' },
      },
      {
        path: 'productTopic/index',
        name: 'productTopic',
        component: () => import('@/views/goods/productTopic/index'),
        meta: { title: '专题管理', id: '2-16', role: [], icon: 'topic' },
      },
      {
        path: 'addTopic',
        name: 'addTopic',
        component: () => import('@/views/goods/productTopic/addTopic'),
        meta: { title: '新增专题', id: '2-17', role: [], is_children: true, children_path: '/productTopic/addTopic' },
        hidden: true
      },
      {
        path: 'upGoods',
        name: 'upGoods',
        component: () => import('@/views/goods/up/upGoods'),
        meta: { title: '上架商品', id: '2-6', role: [], is_children: true, children_path: '/goods/up' },
        hidden: true
      },
      {
        path: 'batchUpdate',
        name: 'batchUpdate',
        component: () => import('@/views/goods/up/batchUpdate'),
        meta: { title: '批量修改', id: '2-20', role: [], is_children: true, children_path: '/goods/up' },
        hidden: true
      },
      {
        path: 'addCategory',
        name: 'addCategory',
        component: () => import('@/views/goods/category/addCategory'),
        meta: { title: '添加商品类目', id: '2-7',  role: [], is_children: true, children_path: '/goods/category' },
        hidden: true
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/goods/product/addProduct'),
        meta: { title: '添加商品', id: '2-8',  role: [], is_children: true, children_path: '/goods/product' },
        hidden: true
      },
      {
        path: 'skuGroup',
        name: 'SkuGroup',
        component: () => import('@/views/goods/skuGroup/index'),
        meta: { title: '规格方案管理',  role: [], id: '2-9', icon: 'sku' },
      },
      {
        path: 'check',
        name: 'check',
        component: () => import('@/views/goods/check/index'),
        meta: { title: '检测管理',  role: [], id: '2-10', icon: 'eye' },
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/goods/banner'),
        meta: { title: '海报管理', id: '2-11',  role: [], icon: 'sms-ad' },
      },
      {
        path: 'addBanner',
        name: 'addBanner',
        component: () => import('@/views/goods/banner/addBanner'),
        meta: { title: '添加海报', id: '2-12',  role: [], is_children: true, children_path: '/goods/banner' },
        hidden: true
      },
      {
        path: 'collage',
        name: 'Collage',
        component: () => import('@/views/goods/collage'),
        meta: { title: '拼单管理',  role: [], id: '2-13', icon: 'product-list' },
      },
      {
        path: '/collage',
        name: 'Addcollage',
        component: () => import('@/views/goods/collage/addCollage'),
        meta: { title: '新建拼团活动', id: '2-14',  role: [], is_children: true, children_path: '/goods/collage' },
        hidden: true
      },
      {
        path: 'arrival',
        name: 'Arrival',
        component: () => import('@/views/goods/reminder/arrival'),
        meta: { title: '到货提醒', id: '2-15',  role: [], icon: 'arriver_news' },
      },
      {
        path: 'marketing',
        name: 'Marketing',
        component: () => import('@/views/goods/marketing/index'),
        meta: { title: '营销活动', id: '2-18',  role: [], icon: 'goodData' },
      },
      {
        path: 'editMarketing',
        name: 'EditMarketing',
        component: () => import('@/views/goods/marketing/edit'),
        meta: { title: '编辑营销活动', id: '2-19', role: [], is_children: true, children_path: '/goods/marketing' },
        hidden: true
      },
      {
        path: 'inspection',
        name: 'Inspection',
        component: () => import('@/views/goods/inspection/index'),
        meta: { title: '彩虹检测', id: '2-22',  role: [], icon: 'inspection' },
      },
      {
        path: 'editInspection',
        name: 'EditInspection',
        component: () => import('@/views/goods/inspection/edit'),
        meta: { title: '编辑彩虹检测', id: '2-21', role: [], is_children: true, children_path: '/goods/inspection' },
        hidden: true
      },
    ],
  },
  //订单管理
  {
    path: '/orderManage',
    component: Layout,
    redirect: '/orderManage/order',
    name: 'orderManage',
    meta: { title: '订单管理', id: '3',  role: [], icon: 'order' },
    children: [{
      path: 'order',
      name: 'order',
      component: () => import('@/views/orderManage/order/index'),
      meta: { title: '订单管理', id: '3-1',  role: [], icon: 'order-setting', keepAlive: true }
    },
    {
      path: 'DOUYINorder',
      name: 'DOUYINorder',
      component: () => import('@/views/orderManage/order/DOUYINorder'),
      meta: { title: '抖音订单管理', id: '3-2',  role: [], icon: 'order-setting', keepAlive: true }
    },
    {
      path: 'wdorder',
      name: 'Wdorder',
      component: () => import('@/views/orderManage/wdOrderList'),
      meta: { title: '旺店通订单列表', id: '3-3',  role: [], icon: 'wdt', keepAlive: true }
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/orderManage/order/detail'),
      meta: { title: '订单详情', id: '3-4',  role: [], is_children: true, children_path: '/orderManage/order' },
      hidden: true
    },
    {
      path: 'problemOrder',
      name: 'problemOrder',
      component: () => import('@/views/orderManage/problemOrder/index'),
      meta: { title: '售后订单管理', id: '3-5',  role: [], icon: 'order-return' }
    },
    {
      path: 'problemDetail',
      name: 'problemDetail',
      component: () => import('@/views/orderManage/problemOrder/detail'),
      meta: { title: '售后订单详情', id: '3-6',  role: [], is_children: true, children_path: '/orderManage/problemOrder' },
      hidden: true
    },
    {
      path: 'express',
      name: 'express',
      component: () => import('@/views/orderManage/express/index'),
      meta: { title: '快递发货', id: '3-7',  role: [], icon: 'order-return-reason' }
    },
    {
      path: 'record',
      name: 'record',
      component: () => import('@/views/orderManage/order/record'),
      meta: { title: '导入记录', id: '3-8', role: [], is_children: true, children_path: '/orderManage/express' },
      hidden: true
    },
    {
      path: 'comment',
      name: 'Comment',
      component: () => import('@/views/orderManage/comment/index'),
      meta: { title: '评价管理', id: '3-9',  role: [], icon: 'product-comment' }
    },
    {
      path: 'toOrder',
      name: 'ToOrder',
      component: () => import('@/views/orderManage/toOrder/index'),
      meta: { title: '同步至旺店通', id: '3-10',  role: [], icon: 'wdt' }
    },
    {
      path: 'importOrder',
      name: 'ImportOrder',
      component: () => import('@/views/orderManage/order/importOrder'),
      meta: { title: '导入订单', id: '3-11',  role: [], icon: 'importOrder' }
    },
    {
      path: 'sfExpress',
      name: 'SfExpress',
      component: () => import('@/views/orderManage/sfExpress/index'),
      meta: { title: '顺丰订单', id: '3-12',  role: [], icon: 'order-return' }
    },
  ],
  },
  // 抖音周期购
  {
    path: '/Tiktok',
    component: Layout,
    redirect: '/Tiktok/modify',
    name: 'tiktok',
    meta: { title: '抖音周期购', id: '24',  role: [], icon: 'sku' },
    children: [
      {
        path: 'modify',
        name: 'modify',
        component: () => import('@/views/tiktok/modify'),
        meta: { title: '订单修改工单', id: '24-1',  role: [], icon: 'product-list' }
      },
      {
        path: 'tikbind',
        name: 'tikbind',
        component: () => import('@/views/tiktok/index'),
        meta: { title: '抖音周期购绑定', id: '24-2',  role: [], icon: 'custom' }
      },
    ]
  },
  // {
  //   path: '/coupon',
  //   component: Layout,
  //   redirect: '/coupon/index',
  //   name: 'Coupon',
  //   meta: { title: '优惠券管理', id: '25',  role: [], icon: 'coupon' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'CouponIndex',
  //       component: () => import('@/views/coupon/index'),
  //       meta: { title: '优惠券管理', id: '25-1',  role: [], icon: 'coupon' }
  //     }
  //   ]
  // },
  {
    path: '/coupon',
    component: Layout,
    redirect: '/coupon/index',
    name: 'Coupon',
    meta: { title: '优惠券管理', id: '27',  role: [], icon: 'coupon' },
    children: [
      {
        path: 'index',
        name: 'wxCoupon',
        component: () => import('@/views/coupon/wxCoupon'),
        meta: { title: '优惠券管理', id: '27-1',  role: [], icon: 'coupon' }
      },
      {
        path: 'createCoupon',
        name: 'CreateCoupon',
        component: () => import('@/views/coupon/createCoupon'),
        meta: { title: '新建领券活动', id: '27-2', role: [], is_children: true, children_path: '/coupon/createCoupon' },
        hidden: true
      },
    ]
  },
  {
    path: '/live2',
    component: Layout,
    redirect: '/live2/index',
    name: 'Live2',
    meta: { title: '产地直播', id: '29',  role: [], icon: 'live2' },
    children: [
      {
        path: 'index',
        name: 'Live2Index',
        component: () => import('@/views/live2/index'),
        meta: { title: '产地直播', id: '29-1',  role: [], icon: 'live2' }
      },
      {
        path: 'editLive2',
        name: 'EditLive2',
        component: () => import('@/views/live2/edit'),
        meta: { title: '编辑直播', id: '29-2', role: [], is_children: true, children_path: '/live2/index' },
        hidden: true
      },
    ]
  },
  {
    path: '/foodStamps',
    component: Layout,
    redirect: '/foodStamps/index',
    name: 'stamps',
    meta: { title: '粮票管理', id: '28',  role: [], icon: 'stamps' },
    children: [
      {
        path: 'index',
        name: 'Stamps',
        component: () => import('@/views/foodStamps/index'),
        meta: { title: '粮票列表', id: '28-1',  role: [], icon: 'stamps-list' }
      },
      {
        path: 'createFoodStamps',
        name: 'CreateFoodStamps',
        component: () => import('@/views/foodStamps/addStamps'),
        meta: { title: '新增粮票', id: '28-2', role: [], is_children: true, children_path: '/stamps/addStamps' },
        hidden: true
      },
      {
        path: 'grantRecord',
        name: 'GrantRecord',
        component: () => import('@/views/foodStamps/grantRecords'),
        meta: { title: '发放记录', id: '28-3',  role: [], icon: 'grant' }
      },
    ]
  },
  {
    path: '/active',
    component: Layout,
    redirect: '/active/index',
    name: 'Active',
    meta: { title: '营销活动管理', id: '26',  role: [], icon: 'active' },
    children: [
      {
        path: 'index',
        name: 'activeGift',
        component: () => import('@/views/active/index'),
        meta: { title: '赠品管理', id: '26-1',  role: [], icon: 'active' }
      }
    ]
  },
  //彩虹talk
  {
    path: '/talk',
    component: Layout,
    redirect: '/talk/notice',
    name: 'talk',
    meta: { title: '彩虹TALK', id: '30',  role: [], icon: 'talk' },
    children: [{
      path: 'notice',
      name: 'notice',
      component: () => import('@/views/talk/notice'),
      meta: { title: '公告管理', id: '30-1',  role: [], icon: 'talk-notice' }
    },{
      path: 'banner',
      name: 'banner',
      component: () => import('@/views/talk/banner'),
      meta: { title: 'Banner管理', id: '30-2',  role: [], icon: 'talk-image' }
    },
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/talk/video'),
        meta: { title: '视频管理', id: '30-3',  role: [], icon: 'talk-video' }
      },
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/talk/category'),
        meta: { title: '分类管理', id: '30-4',  role: [], icon: 'talk-category' }
      },
      {
        path: 'expertType',
        name: 'expertType',
        component: () => import('@/views/talk/expertType'),
        meta: { title: '专家类型', id: '30-5',  role: [], icon: 'talk-expert-type' }
      },
      {
        path: 'expert',
        name: 'expert',
        component: () => import('@/views/talk/expert'),
        meta: { title: '专家管理', id: '30-6',  role: [], icon: 'talk-expert' }
      },
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/talk/message'),
        meta: { title: '留言管理', id: '30-7',  role: [], icon: 'talk-message' }
      },
    ],
  },
  //分销管理
  {
    path: '/organization',
    component: Layout,
    redirect: '/organization/organizationList',
    name: 'organization',
    meta: { title: '分销管理', id: '4',  role: [], icon: 'tree' },
    children: [{
      path: 'organizationList',
      name: 'organizationList',
      component: () => import('@/views/organization/organizationList/index'),
      meta: { title: '合伙人管理', id: '4-1',  role: [], icon: 'example' }
    },
    {
      path: 'orzRecord',
      name: 'orzRecord',
      component: () => import('@/views/organization/organizationList/record'),
      meta: { title: '合伙人收益流水', id: '4-2', role: [], is_children: true, children_path: '/organization/organizationList' },
      hidden: true
    },
    {
      path: 'orzDetail',
      name: 'orzDetail',
      component: () => import('@/views/organization/organizationList/detail'),
      meta: { title: '合伙人详情', id: '4-3',  role: [], is_children: true, children_path: '/organization/organizationList' },
      hidden: true
    },
    {
      path: 'applyPresident',
      name: 'ApplyPresident',
      component: () => import('@/views/organization/applyPresident/index'),
      meta: { title: '申请社长', id: '4-4',  role: [], icon: 'applyPresident' }
    },
    {
      path: 'president',
      name: 'president',
      component: () => import('@/views/organization/president/index'),
      meta: { title: '社长管理', id: '4-5',  role: [], icon: 'sms-new' }
    },
    {
      path: 'presidentDetail',
      name: 'presidentDetail',
      component: () => import('@/views/organization/president/detail'),
      meta: { title: '社长详情', id: '4-6', role: [], is_children: true, children_path: '/organization/president' },
      hidden: true
    },
    {
      path: 'incomeRecord',
      name: 'incomeRecord',
      component: () => import('@/views/organization/president/incomeRecord'),
      meta: { title: '收益行为记录', id: '4-7',  role: [], is_children: true, children_path: '/organization/president' },
      hidden: true
    },
    {
      path: 'cashManage',
      name: 'cashManage',
      component: () => import('@/views/organization/cashManage/index'),
      meta: { title: '提现审批', id: '4-8',  role: [], icon: 'sms-subject' }
    },
    {
      path: 'parcel',
      name: 'parcel',
      component: () => import('@/views/organization/parcel/index'),
      meta: { title: '礼包订单', id: '4-9',  role: [], icon: 'product-list' }
    },
    {
      path: 'parcelDetail',
      name: 'parcelDetail',
      component: () => import('@/views/organization/parcel/detail'),
      meta: { title: '礼包详情', id: '4-10',  role: [], is_children: true, children_path: '/organization/parcel' },
      hidden: true
    },
    {
      path: 'giftPackage',
      name: 'giftPackage',
      component: () => import('@/views/organization/giftPackage/index'),
      meta: { title: '社长礼包发放', id: '4-11', role: [],  icon: 'sms-flash' }
    },
      {
        path: 'deposit',
        name: 'depositList',
        component: () => import('@/views/organization/deposit/index'),
        meta: { title: '开店保证金', id: '4-12',  role: [], icon: 'example' }
      },
    ],
  },
  // 大客户管理
  {
    path: '/keyAccount',
    component: Layout,
    redirect: '/keyAccount/keyAccountList',
    name: 'keyAccount',
    meta: { title: '大客户管理', id: '21', role: [], icon: 'marker' },
    children: [{
      path: 'screen',
      name: 'screen',
      component: () => import('@/views//keyAccount/screen/index'),
      meta: { title: '人群筛选', id: '21-1', role: [], icon: 'user' }
    },
    {
      path: 'keyAccountList',
      name: 'keyAccountList',
      component: () => import('@/views//keyAccount/keyAccountList/index'),
      meta: { title: '大客户列表', id: '21-2', role: [], icon: 'table' }
    },
    {
      path: 'flowDetails',
      name: 'FlowDetails',
      component: () => import('@/views/keyAccount/flowDetails'),
      meta: { title: '流水明细', id: '21-3', is_children: true, role: [], children_path: '/flowDetails' },
      hidden: true
    }
  ],
  },
  // 创始社员管理
  {
    path: '/starFirstVip',
    component: Layout,
    redirect: '/starFirstVip/starFirstVip',
    name: 'starFirstVip',
    meta: { title: '社员管理', id: '5', role: [], icon: 'star' },
    children: [
      {
        path: 'starFirstVip',
        name: 'starFirstVip',
        component: () => import('@/views/organization/starFirstVip/index'),
        meta: { title: '创始社员管理', id: '5-1', role: [], icon: 'star' }
      },
      {
        path: 'presidentApplay',
        name: 'PresidentApplay',
        component: () => import('@/views/organization/presidentApplay/index'),
        meta: { title: '社员申请', id: '5-2', role: [], icon: 'applyPresident' }
      },
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/organization/memberManage/index'),
        meta: { title: '社员管理', id: '5-3', role: [], icon: 'admin-manage' }
      },
    ],
  },
  // 用户管理
  {
    path: '/member',
    component: Layout,
    redirect: '/member/member',
    name: 'member',
    meta: { title: '用户管理', id: '6', role: [], icon: 'marker' },
    children: [{
      path: 'member',
      name: 'member',
      component: () => import('@/views/member/member/index'),
      meta: { title: '用户管理', id: '6-1', role: [], icon: 'marker' }
    },{
      path: 'ban',
      name: 'ban',
      component: () => import('@/views/member/member/ban'),
      meta: { title: '恶意用户管理', id: '6-2', role: [] },
      hidden: true
    }],
  },
  // 返现管理
  {
    path: '/profit',
    component: Layout,
    redirect: '/profit/profit',
    name: 'profit',
    meta: { title: '返现管理', id: '7', role: [], icon: 'sms-subject' },
    children: [{
      path: 'profit',
      name: 'profitList',
      component: () => import('@/views/profit/profit/index'),
      meta: { title: '返现管理', id: '7-1', role: [], icon: 'sms-subject' }
    }],
  },
  // 手动退款管理
  {
    path: '/refund',
    component: Layout,
    redirect: '/refund/refund',
    name: 'refund',
    meta: { title: '手动退款管理', id: '8', role: [], icon: 'sms-flash' },
    children: [{
      path: 'refund',
      name: 'refundList',
      component: () => import('@/views/refund/refund/index'),
      meta: { title: '手动退款管理', id: '8-1', role: [], icon: 'sms-flash' }
    }],
  },
  // 数据管理
  {
    path: '/dataMan',
    component: Layout,
    redirect: '/dataMan/rfm',
    name: 'DataMan',
    meta: { title: '数据管理', id: '9', role: [], icon: 'data' },
    children: [
    {
      path: 'rfm',
      name: 'RFM',
      component: () => import('@/views/dataMan/rfm'),
      meta: { title: 'RFM', id: '9-1', role: [],  icon: 'RFM' }
    },
    {
      path: 'keepAccount',
      name: 'KeepAccount',
      component: () => import('@/views/dataMan/keepAccount'),
      meta: { title: '客户成交留存', id: '9-2', role: [],  icon: 'saveData' }
    },
    {
      path: 'goodData',
      name: 'GoodData',
      component: () => import('@/views/dataMan/goodData'),
      meta: { title: '商品数据', id: '9-3', role: [],  icon: 'goodData' }
    },
    {
      path: 'deliverGoods',
      name: 'DeliverGoods',
      component: () => import('@/views/dataMan/deliverGoods'),
      meta: { title: '产品待发货排期', id: '9-4', role: [],  icon: 'saveData' }
    },
    {
      path: 'newGoodsData',
      name: 'NewGoodsData',
      component: () => import('@/views/dataMan/newGoodsData'),
      meta: { title: '商品数据（新）', id: '9-5', role: [],  icon: 'goods_data' }
    },
    {
      path: 'cardData',
      name: 'CardData',
      component: () => import('@/views/dataMan/cardData'),
      meta: { title: '礼品卡数据', id: '9-6', role: [],  icon: 'cardData' }
    },
    {
      path: 'orderSurplus',
      name: 'OrderSurplus',
      component: () => import('@/views/dataMan/orderSurplus'),
      meta: { title: '年定数据', id: '9-7', role: [],  icon: 'orderSurplus' }
    },
    {
      path: 'record',
      name: 'Record',
      component: () => import('@/views/dataMan/record'),
      meta: { title: '明细', id: '9-8', is_children: true, role: [],  children_path: '/record' },
      hidden: true
    }],
  },
  // 直播管理
  {
    path: '/live',
    component: Layout,
    redirect: '/live/liveShare',
    name: 'live',
    meta: { title: '直播管理', id: '10', role: [],  icon: 'live' },
    children: [
      {
        path: 'liveShare',
        name: 'liveShare',
        component: () => import('@/views/live/share/index'),
        meta: { title: '直播管理', id: '10-1', role: [],  icon: 'live' },
      },
      {
        path: 'liveShareCreate',
        name: 'liveShareCreate',
        component: () => import('@/views/live/room/Create'),
        meta: { title: '创建直播', id: '10-2', is_children: true, role: [],  children_path: '/live/liveShare' },
        hidden: true
      },
      {
        path: 'subscribeRoom',
        name: 'subscribeRoom',
        component: () => import('@/views/live/share/subscribeRoom'),
        meta: { title: '订阅详情', id: '10-3', is_children: true, children_path: '/live/liveShare' },
        hidden: true
      },
      {
        path: 'liveSharer',
        name: 'liveSharer',
        component: () => import('@/views/live/share/liveSharer'),
        meta: { title: '直播分享详情', id: '10-4', is_children: true, role: [], children_path: '/live/liveShare' },
        hidden: true
      },
    ],
  },
  // 礼品卡
  {
    path: '/giftCard',
    component: Layout,
    redirect: '/giftCard/giftCard',
    name: 'GiftCardMan',
    meta: { title: '礼品卡管理', id: '11', role: [], icon: 'giftCards' },
    children: [{
      path: 'giftCard',
      name: 'GiftCard',
      component: () => import('@/views/giftCard/giftCard/index'),
      meta: { title: '礼品卡管理', id: '11-1', role: [], icon: 'giftCard' }
    },
      {
        path: 'card',
        name: 'Card',
        component: () => import('@/views/giftCard/giftCard/card'),
        meta: { title: '实体卡列表', id: '11-1', is_children: true, role: [], children_path: '/giftCard/giftCard' },
        hidden: true
      },
    {
      path: 'cardPurchaseRecord',
      name: 'CardPurchaseRecord',
      component: () => import('@/views/giftCard/cardPurchaseRecord/index'),
      meta: { title: '购卡记录', id: '11-2', role: [], icon: 'buyCardRecord' }
    },
    {
      path: 'buyCardUser',
      name: 'BuyCardUser',
      component: () => import('@/views/giftCard/buyCardUser/index'),
      meta: { title: '购卡用户记录', id: '11-3', role: [], icon: 'buyCardUser' }
    },
      {
        path: 'orderCHDRecord',
        name: 'OrderCHDRecord',
        component: () => import('@/views/giftCard/orderCHDRecord/index'),
        meta: { title: '彩虹豆兑换记录', id: '11-4', role: [], icon: 'orderCHD' }
      }],

  },
  // 礼品卡购买记录
  // {
  //   path: '/cardPurchaseRecord',
  //   component: Layout,
  //   redirect: '/giftCard/cardPurchaseRecord',
  //   name: 'GiftCardMan',
  //   meta: { title: '提现列表', id: '20', icon: 'total-today' },
  //   children: [{
  //     path: 'cardPurchaseRecord',
  //     name: 'CardPurchaseRecord',
  //     component: () => import('@/views/giftCard/cardPurchaseRecord/index'),
  //     meta: { title: '购卡记录', id: '20-1', icon: 'giftCard' }
  //   }],
  // },
  // 提现列表
  {
    path: '/withdraw',
    component: Layout,
    redirect: '/withdraw/withdraw',
    name: 'withdraw',
    meta: { title: '提现列表', id: '12', role: [], icon: 'total-today' },
    children: [{
      path: 'withdraw',
      name: 'withdrawIndex',
      component: () => import('@/views/withdraw/withdraw/index'),
      meta: { title: '提现列表', id: '12-1', role: [], icon: 'total-today' }
    }],
  },
  // 彩虹粉管理
  {
    path: '/fansMan',
    component: Layout,
    redirect: '/fansMan/fans',
    name: 'fansMan',
    meta: { title: '彩虹粉管理', id: '13', role: [], icon: 'sms-new' },
    children: [{
      path: 'fans',
      name: 'fans',
      component: () => import('@/views/member/fans/index'),
      meta: { title: '彩虹粉管理', id: '13-1', role: [], icon: 'sms-new' }
    }],
  },
  // 首页管理
  {
    path: '/indexManage',
    component: Layout,
    redirect: '/indexManage/index',
    name: 'indexManage',
    meta: { title: '首页管理', id: '14', role: [], icon: 'login-mall' },
    children: [
      {
        path: 'indexManage',
        name: 'indexManage',
        component: () => import('@/views/indexManage/index'),
        meta: { title: '首页管理', id: '14-1', role: [], icon: 'login-mall' }
      },
      {
        path: 'searchMan',
        name: 'SearchMan',
        component: () => import('@/views/indexManage/search'),
        meta: { title: '配置管理', id: '14-2', role: [], icon: 'index_search' }
      },
      {
        path: 'popUp',
        name: 'popUp',
        component: () => import('@/views/indexManage/popUp/index'),
        meta: { title: '弹窗管理', id: '14-3', role: [], icon: 'popup' }
      },
      {
        path: 'editPopup',
        name: 'EditPopup',
        component: () => import('@/views/indexManage/popUp/edit'),
        meta: { title: '编辑弹窗', id: '14-4', role: [], is_children: true, children_path: '/indexManage/popUp' },
        hidden: true
      },
    ],
  },
  // 彩虹播报
  {
    path: '/noticeMan',
    component: Layout,
    redirect: '/noticeMan/notice',
    name: 'noticeMan',
    meta: { title: '彩虹播报', id: '15', role: [], icon: 'notice' },
    children: [{
      path: 'notice',
      name: 'Notice',
      component: () => import('@/views/notice/index'),
      meta: { title: '彩虹播报', id: '15-1', role: [], icon: 'notice' }
    }],
  },
  // 反向定制
  {
    path: '/customMan',
    component: Layout,
    redirect: '/customMan/custom',
    name: 'customMan',
    meta: { title: '反向定制', id: '16', role: [], icon: 'custom' },
    children: [{
      path: 'custom',
      name: 'Custom',
      component: () => import('@/views/custom/index'),
      meta: { title: '反向定制', id: '16-1', role: [], icon: 'custom' }
    }],
  },
  // 心愿清单
  {
    path: '/wishMan',
    component: Layout,
    redirect: '/wishMan/custom',
    name: 'WishMan',
    meta: { title: '心愿清单', id: '17', role: [], icon: 'wishIcon' },
    children: [{
      path: 'wish',
      name: 'Wish',
      component: () => import('@/views/wish/index'),
      meta: { title: '心愿清单', id: '17-1', role: [], icon: 'wishIcon' }
    }],
  },
  // 知识库
  {
    path: '/knowledgeMan',
    component: Layout,
    redirect: '/knowledgeMan/knowledge',
    name: 'Knowledgeman',
    meta: { title: '知识库', id: '23', role: [], icon: 'product-attr' },
    children: [{
      path: 'knowledge',
      name: 'Knowledge',
      component: () => import('@/views/knowledge/index'),
      meta: { title: '知识库列表', id: '23-1', role: [], icon: 'product-attr' }
    },
    {
      path: 'add',
      name: 'Add',
      component: () => import('@/views/knowledge/add'),
      meta: { title: '问答列表', id: '23-2', is_children: true, role: [], children_path: '/knowledge' },
      hidden: true
    },],
  },
  //日志
  {
    path: '/logs',
    component: Layout,
    redirect: '/logs/log',
    name: 'logs',
    meta: { title: '日志管理', id: '18', role: [], icon: 'table' },
    children: [{
      path: 'log',
      name: 'log',
      component: () => import('@/views/logs/log/index'),
      meta: { title: '运营日志', id: '18-1', role: [], icon: 'form' }
    },
    {
      path: 'userLog',
      name: 'userLog',
      component: () => import('@/views/logs/userLog/index'),
      meta: { title: '用户日志', id: '18-2', role: [], icon: 'user' }
    },],
  },
  {
    path: '/manager',
    component: Layout,
    redirect: '/manager/managerList',
    name: 'manager',
    meta: { title: '管理员', id: '19', role: [], icon: 'manager' },
    children: [
      {
        path: 'managerList',
        name: 'managerList',
        component: () => import('@/views/manager/managerList/index'),
        meta: { title: '角色管理', id: '19-1', role: [], icon: 'base_manage' }
      },
      {
        path: 'manageUser',
        name: 'ManageUser',
        component: () => import('@/views/manager/manageUser'),
        meta: { title: '用户管理', id: '19-2', role: [], icon: 'manage_user' }
      },
      {
        path: 'addUser',
        name: 'Adduser',
        component: () => import('@/views/manager/addUser'),
        meta: { title: '新增角色', id: '19-3', role: [], },
        hidden: true
      },
      // {
      //   path: '/manager/fixedPassword',
      //   component: () => import('@/views/manager/fixedPassword'),
      //   meta: { title: '修改密码', id: '19-4', icon: 'user', role: [], },
      //   hidden: true
      // }
    ],
  }
]

const notFound = [
  { path: '*', redirect: '/404', hidden: true }
]

export { asyncRoutes, notFound }

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js